import { CircularProgress, Grid, Stack, TextField, Typography } from "@mui/material";
import React, { useCallback, useMemo } from "react";
import LoadingButtonStyled from "../../atoms/v2/LoadingButton";
import { ReactComponent as CuponSVG } from "../../../assets/svg/cupon.svg";
import { CuponProps, IFormData } from "./Cupon.model";
import _ from "lodash";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./Cupon.schema";

const Cupon = ({ onSubmit }: CuponProps) => {
  const defaultValues = useMemo(() => {
    const data: IFormData = {
      code: "",
    };
    return data;
  }, []);
  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useForm({
    defaultValues: defaultValues,
    mode: "all",
    resolver: yupResolver(schema) as any,
  });

  const custonOnSubmit = useCallback(
    async (data: IFormData) => {
      if (typeof onSubmit === "function") {
        const rawCode = data.code;
        const deburred = _.deburr(rawCode);
        const camelCased = _.camelCase(deburred);
        const upper = _.toUpper(camelCased);
        const sanitized = upper.replace(/\s+/g, "");
        await onSubmit(sanitized);
      }
    },
    [onSubmit]
  );

  return (
    <form onSubmit={handleSubmit(custonOnSubmit)}>
      <Stack
        style={{
          display: "flex",
          flexDirection: "column",
        }}
        spacing={4}
      >
        <img
          alt="Cupon"
          style={{
            width: "100%",
            borderRadius: 20,
            alignSelf: "center",
            maxWidth: 400,
          }}
          src={require("../../../assets/images/cupon.jpg")}
        />
        <Stack spacing={1}>
          <Typography variant="body1" textAlign="center">
            Paga con tarjeta de crédito o débito
          </Typography>
          <Grid container spacing={0.5} maxWidth={230} alignSelf="center">
            <Grid xs={3} item>
              <div style={{ height: 25 }}>
                <img
                  alt="visa"
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                  }}
                  src="visa.png"
                />
              </div>
            </Grid>
            <Grid xs={3} item>
              <div style={{ height: 25 }}>
                <img
                  alt="mastercard"
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                  }}
                  src="mastercard.png"
                />
              </div>
            </Grid>
            <Grid xs={3} item>
              <div style={{ height: 25 }}>
                <img
                  alt="american-express"
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                  }}
                  src="american-express.png"
                />
              </div>
            </Grid>
            <Grid xs={3} item>
              <div style={{ height: 25 }}>
                <img
                  alt="diners-club"
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                  }}
                  src="diners-club.png"
                />
              </div>
            </Grid>
          </Grid>
        </Stack>
        <Stack spacing={2}>
          <Typography variant="body1" textAlign="center">
            ¿Tienes un cupón de descuento?
          </Typography>
          <Typography variant="body2" textAlign="left">
            Si no cuentas con un cupón, continúa con el siguiente paso
          </Typography>
          <Controller
            control={control}
            name="code"
            render={({ field: { onBlur, onChange, value }, fieldState }) => (
              <TextField
                id="outlined-basic"
                label="Cupón de descuento"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <CuponSVG
                      width={30}
                      height={30}
                      fill="#737373"
                      style={{ marginLeft: 10 }}
                    />
                  ),
                }}
                inputProps={{
                  style: { textTransform: "uppercase" },
                }}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                helperText="Si no tienes cupón, no completes"
              />
            )}
          />
        </Stack>
        <LoadingButtonStyled
          type="submit"
          loading={isSubmitting}
          loadingIndicator={<CircularProgress color="primary" size={24} />}
          disabled={isValid === false}
          variant="contained"
        >
          Siguiente
        </LoadingButtonStyled>
      </Stack>
    </form>
  );
};

export { Cupon };
